module.exports = __webpack_public_path__ + "static/media/location-dark.9f0d841d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/location-dark.svg
// module id = 53
// module chunks = 0